import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $('select.select2:not(.select2-hidden-accessible)').select2({
      language: "pt-BR",
      placeholder: 'Todos',
      allowClear: true,
      multiple: true,
      width: '500px',
    });

		return this;
  }
}